import { Environment } from '@apis/common';
import mixpanel from 'mixpanel-browser';

export interface MixpanelUserProperties {
    id: number;
    $name: string;
    $email: string;
    companyId: number;
    companyName: string;
    environment: Environment;
}

export enum MixpanelEvents {
    CompanyLogin = 'CompanyLogin',
    Login = 'Login',
    Logout = 'Logout',
    PageView = 'Page View',
    AudioPlayed = 'Audio Played',
    ViewLogin = 'View Login',
    ViewCompanyLogin = 'View Company Login',
    ViewForgotPassword = 'View Forgot Password',
    ViewConfirmAccount = ' View Confirm Account',
    ViewOauthLogin = ' View Oauth Login',
    ViewNotFound = ' View Not Found',
    ViewTrial = 'View Trial',
    ViewLogsDebug = ' View Logs Debug',
    ViewDashboard = ' View Dashboard',
    ViewOperationsSearch = ' View Operations Search',
    ViewClientSearch = ' View Client Search',
    ViewClientSearchHistory = ' View Client Search History',
    ViewPhoneSearch = ' View Phone Search',
    ViewAlertList = ' View Alert List',
    ViewAlertDetails = ' View Alert Details',
    ViewGroupedPhoneAlerts = ' View Grouped Phone Alerts',
    ViewGroupedVoiceAlerts = ' View Grouped Voice Alerts',
    ViewFlagResultHistory = ' View Flag Result History',
    ViewFlagsFinishAnalysis = ' View Flag Finish Analysis',
    ViewWatchlists = ' View Watchlists',
    ViewWatchlistPhones = ' View Watchlist Phones',
    ViewWatchlistVoices = ' View Watchlist Voices',
    ViewWatchlistAudiosTab = ' View Watchlist Audios Tab',
    ViewWatchlistConfig = ' View Watchlist Config',
    ViewWatchlistAutomations = ' View Watchlist Automations',
    ViewCertifiedBiometrics = ' View Certified Biometrics',
    ViewCertifiedBiometricsInsert = ' View Certified Biometrics Insert',
    ViewCertifiedBiometricsImportInsert = ' View Certified Biometrics Import Insert',
    ViewCertifiedBiometricsImportRemoval = ' View Certified Biometrics Import Removal',
    ViewSilencedList = ' View Silenced List',
    ViewSilencedListInsert = ' View Silenced List Insert',
    ViewSilencedListImport = ' View Silenced List Import',
    ViewSilencedListHistory = ' View Silenced List History',
    ViewConfig = ' View Config',
    ViewOperationsReport = 'View Operations Report',
    ViewCertifiedBiometricsReport = 'View Certified Biometrics Report',
    ViewCertifiedBiometricsReportDetails = 'View Certified Biometrics Report Details',
    ViewOperationalVisionReport = 'View Operational Vision Report',
    ViewOperationalVisionReportDetails = 'View Operational Vision Report Details',
    ViewCertifiedAuthenticationsReport = 'View Certified Authentications Report',
    ViewInviteUsers = ' View Invite users',
    ViewManageUsers = ' View Manage Users',
    ViewManageProfile = ' View Manage Profile',
    ViewProfileAssociation = ' View Profile Association',
    ViewResetPassword = ' View Reset Password',
    ResetUserPassword = 'Reset User Password',
    CopyPasswordReset = 'Copy Password Reset',
    SendPasswordResetToAdmin = 'Send Password Reset To Admin',
    ChangeUserStatus = 'Change User Status',
    EditUser = 'Edit User',
    ViewAlertTemplates = ' View Alert Templates',
    ViewEditCreateProfile = ' View Edit Create Profile',
    ViewEditCreateTemplate = ' View Edit Create Template',
    ViewWebhooksConfig = ' View Webhooks',
    EditWebhook = ' Edit Webhook',
    ViewWebhooksConfigDetails = ' View Webhooks Details',
    ViewApiTokens = ' View API Tokens',
    RevokeApiToken = 'Revoke API Token',
    CopyApiToken = 'Copy API Token',
    RevealApiToken = 'Reveal API Token',
    CreateApiToken = 'Create API Token',
    ViewClientSecret = ' View Client Secret',
    RevokeClientSecret = 'Revoke Client Secret',
    CreateClientSecret = 'Create Client Secret',
    RevealClientSecret = 'Reveal Client Secret',
    CopyClientSecret = 'Copy Client Secret',
    DeactivateNewAlertTemplate = 'Deactivate New Alert Template',
    EditNewAlertTemplate = 'Edit New Alert Template',
    CreateNewAlertTemplate = 'Create New Alert Template',
    DeactivateProfile = 'Deactivate Profile',
    EditProfile = 'Edit Profile',
    InviteUser = 'Invite User',
    ViewLogs = ' View Logs',
    ViewGeneralConfigCompany = ' View General Config Company',
    ViewGeneralConfigBiometrics = ' View General Config Biometrics',
    ViewGeneralConfigAntifraud = ' View General Config Antifraud',
    ViewGeneralConfigGenesys = ' View General Config Genesys',
    ViewCustomerDetails = ' View Customer Details',
    ViewUserDetails = ' View User Details',
    ViewPublic = '',
    RemovePhoneFromBlocklist = 'Remove Phone from Blocklist',
    RemoveVoiceFromBlocklist = 'Remove Voice from Blocklist',
    AddPhoneToWatchlist = 'Add Phone to Watchlist',
    AddVoiceToWatchlist = 'Add Voice to Watchlist',
    RemovePhoneFromWatchlist = 'Remove Phone from Watchlist',
    RemoveVoiceFromWatchlist = 'Remove Voice from Watchlist',
    BiometricsCardClick = 'Biometrics Card Click',
    ButtonClick = 'Button Click',
    Enrollment = 'Enrollment',
    Authentication = 'Authentication',
    AddVoiceFromVerification = 'Add Voice to Blocklist from Verification',
    FinishFlagAnalysis = 'Finish Flag Analysis',
    FinishFlagAnalysisBatch = 'Finish Flag Analysis Batch',
    UpdateFlagResult = 'Update Flag Result',
    UpdateFlagResultBatch = 'Update Flag Result Batch',
    ViewCustomers = 'View Customers',
    ViewFlagsReport = 'View Flags Report',
    ViewWatchlistValidationReport = 'View Watchlist Validation Report',
    ViewApiDocs = 'View API Docs',
    ViewAllowlistValidationReport = 'View Allowlist Validation Report',
    ViewCredibilityReport = 'View Credibility Report',
    ViewClientSearchTimeline = 'View Client Search Timeline',
    ViewPhoneSearchTimeline = 'View Phone Search Timeline',
    ViewClientSearchAuthorizedDevices = 'View Client Search Authorized Devices',
    ViewPhoneSearchAuthorizedDevices = 'View Phone Search Authorized Devices',
    AddVoiceOnWatchlist = 'Add Voice on Watchlist',
    ViewCases = 'View Cases',
    ViewCasesOverview = 'View Cases Overview',
    ViewCasesOccurrences = 'View Cases Occurrences',
    ViewCasesHistory = 'View Cases History',
    ViewCasesVoiceMap = 'View Cases Voice Map',
    ViewCasesFraudMap = 'View Cases Fraud Map',
    ViewCasesJourney = 'View Cases Journey',
    ViewCasesAudios = 'View Cases Audios',
    ViewCasesWatchlistHistory = 'View Cases Watchlist History',
    ManageUsersTourFinished = 'Manage Users Tour Finished',
    ManageUsersTourAllDisabled = 'Manage Users Tour All Disabled',
    ManageUsersTourNext = 'Manage Users Tour Next',
    ManageUsersTourBack = 'Manage Users Tour Back',
    ManageUsersTourClose = 'Manage Users Tour Close',
    ManageUsersTourViewAgain = 'Manage Users Tour View Again',
    ManageProfilesTourFinished = 'Manage Profiles Tour Finished',
    ManageProfilesTourAllDisabled = 'Manage Profiles Tour All Disabled',
    ManageProfilesTourNext = 'Manage Profiles Tour Next',
    ManageProfilesTourBack = 'Manage Profiles Tour Back',
    ManageProfilesTourClose = 'Manage Profiles Tour Close',
    ManageProfilesTourViewAgain = 'Manage Profiles Tour View Again',
    CreateProfileTourFinished = 'Create Profile Tour Finished',
    CreateProfileTourAllDisabled = 'Create Profile Tour All Disabled',
    CreateProfileTourNext = 'Create Profile Tour Next',
    CreateProfileTourBack = 'Create Profile Tour Back',
    CreateProfileTourClose = 'Create Profile Tour Close',
    CreateProfileTourViewAgain = 'Create Profile Tour View Again',
    SilencedListPageTourFinished = 'Silenced List Page Tour Finished',
    SilencedListPageTourAllDisabled = 'Silenced List Page Tour All Disabled',
    SilencedListPageTourNext = 'Silenced List Tour Next',
    SilencedListPageTourBack = 'Silenced List Tour Back',
    SilencedListPageTourClose = 'Silenced List Tour Close',
    SilencedListPageTourViewAgain = 'Silenced List Tour View Again',
    SilencedListModalTourFinished = 'Silenced List Modal Tour Finished',
    SilencedListModalTourAllDisabled = 'Silenced List Modal Tour All Disabled',
    SilencedListModalTourNext = 'Silenced List Modal Tour Next',
    SilencedListModalTourBack = 'Silenced List Modal Tour Back',
    SilencedListModalTourClose = 'Silenced List Modal Tour Close',
    WatchlistsTourFinished = 'Watchlists Tour Finished',
    WatchlistsTourAllDisabled = 'Watchlists Tour All Disabled',
    WatchlistsTourNext = 'Watchlists Tour Next',
    WatchlistsTourBack = 'Watchlists Tour Back',
    WatchlistsTourClose = 'Watchlists Tour Close',
    WatchlistsTourViewAgain = 'Watchlists Tour View Again',
    WatchlistDetailsTourFinished = 'Watchlist Details Tour Finished',
    WatchlistDetailsTourAllDisabled = 'Watchlist Details Tour All Disabled',
    WatchlistDetailsTourNext = 'Watchlist Details Tour Next',
    WatchlistDetailsTourBack = 'Watchlist Details Tour Back',
    WatchlistDetailsTourClose = 'Watchlist Details Tour Close',
    WatchlistDetailsTourViewAgain = 'Watchlist Details Tour View Again',
    WatchlistPhoneTourFinished = 'Watchlist Phone Tour Finished',
    WatchlistPhoneTourAllDisabled = 'Watchlist Phone Tour All Disabled',
    WatchlistPhoneTourNext = 'Watchlist Phone Tour Next',
    WatchlistPhoneTourBack = 'Watchlist Phone Tour Back',
    WatchlistPhoneTourClose = 'Watchlist Phone Tour Close',
    WatchlistPhoneTourViewAgain = 'Watchlist Phone Tour View Again',
    WatchlistVoiceTourFinished = 'Watchlist Voice Tour Finished',
    WatchlistVoiceTourAllDisabled = 'Watchlist Voice Tour All Disabled',
    WatchlistVoiceTourNext = 'Watchlist Voice Tour Next',
    WatchlistVoiceTourBack = 'Watchlist Voice Tour Back',
    WatchlistVoiceTourClose = 'Watchlist Voice Tour Close',
    WatchlistVoiceTourViewAgain = 'Watchlist Voice Tour View Again',
    WatchlistsAutomationTourFinished = 'Watchlists Automation Tour Finished',
    WatchlistsAutomationTourAllDisabled = 'Watchlists Automation Tour All Disabled',
    WatchlistsAutomationTourNext = 'Watchlists Automation Tour Next',
    WatchlistsAutomationTourBack = 'Watchlists Automation Tour Back',
    WatchlistsAutomationTourClose = 'Watchlists Automation Tour Close',
    WatchlistsAutomationTourViewAgain = 'Watchlists Automation Tour View Again',
    WatchlistConfigurationTourFinished = 'Watchlist Configuration Tour Finished',
    WatchlistConfigurationTourAllDisabled = 'Watchlist Configuration Tour All Disabled',
    WatchlistConfigurationTourNext = 'Watchlist Configuration Tour Next',
    WatchlistConfigurationTourBack = 'Watchlist Configuration Tour Back',
    WatchlistConfigurationTourClose = 'Watchlist Configuration Tour Close',
    WatchlistConfigurationTourViewAgain = 'Watchlist Configuration Tour View Again',
    SearchGroupedByExternalId = 'Search Grouped By External ID',
}

export interface MixpanelEventProperties {
    [key: string]: string | number | boolean | Date | undefined | null | object;
}

export function useMixpanel() {
    const identify = (id: string) => {
        mixpanel.identify(id);
    };

    const track = (event: string, props?: MixpanelEventProperties) => {
        mixpanel.track(event, props);
    };

    const setUserProperties = (props: MixpanelUserProperties) => {
        mixpanel.people.set(props);
    };

    const login = (user: MixpanelUserProperties) => {
        identify(user.id.toString());

        track(MixpanelEvents.Login, {
            userId: user.id,
            companyId: user.companyId,
            companyName: user.companyName,
            environment: user.environment,
        });

        setUserProperties(user);
    };

    const logout = (email: string) => {
        mixpanel.track(MixpanelEvents.Logout, { email });
        mixpanel.reset();
    };

    return {
        identify,
        track,
        setUserProperties,
        login,
        logout,
    };
}
